import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
  constructor(private router : Router){}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      console.log(localStorage.getItem('JWT'));
      
      if (localStorage.getItem('JWT') === null) 
      {
        this.router.navigate( [ '/authentication/login' ]);
      } 
      else 
      {
        return true;
      }

  }
}
